/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable react/prop-types */
import getConfig from 'next/config';
import dynamic from 'next/dynamic';

import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Head from 'next/head';
import { withRouter } from 'next/router';
import styled from 'styled-components';
import 'url-search-params-polyfill';
import { cookies } from '@binanceus/utils';
import { Footer } from '@binanceus/layout';

import '../utils/createNonce'; // for CSP
import '../utils/polyfills'; // for old browsers

import gtmTrack from '../utils/gtmTrack';
import { login } from '../utils/sensors';
import Header from '../components/Header';
import ReferralDataSetter from '../components/ReferralDataSetter';
import UserCenterHeader from '../components/UserCenter/Header';
import FaceStatus from '../components/UserCenter/FaceStatus';
import SubHead from '../components/UserCenter/Header/SubHead';
import EmergencyNotice from '../components/EmergencyNotice';
import FireFoxWarningTip from '../components/FireFoxWarningTip';
import { verifyToken as verifyTokenRequest, userLoggedOut as userLoggedOutRequest } from '../actions/actionsSet/authcenter';
import { checkLogin } from '../utils/auth';
import { getLoginUrl } from '../utils/urlUtils';
import { createCookie } from '../utils/cookies-browser';

import { getHostName, removeQueryStr, getPathWithoutLocale } from '../utils/canonical';
import zIndexScale from '../utils/zIndexScale';
import {
  fetchInmailData,
  fetchInmailUnreadCount,
  fetchInmailReadOrDelet,
  fetchInmailStreamToken,
  addInmailData,
  updateInmailDataCount,
} from '../actions/actionsSet/inmail';

require('../static/css/base.css');
require('../node_modules/react-tippy/dist/tippy.css');
require('../node_modules/react-virtualized/styles.css');
require('../static/css/iconfont.css');
require('../static/css/nprogress.css');
require('../static/css/overrides.css');

const LocalStorageDataProvider = dynamic(import('../network/LocalStorageDataProvider'), {
  ssr: false,
  loading: () => null,
});

const CommonDataProvider = dynamic(import('../network/CommonDataProvider'), {
  ssr: false,
  loading: () => null,
});

const AbstractSocketProvider = dynamic(import('../network/AbstractSocketProvider'), {
  ssr: false,
  loading: () => null,
});

const {
  publicRuntimeConfig: { assetPrefix, buildId: BUILD_ID, inmailWssUrl },
} = getConfig();

const HTTPS = 'https://';

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  //min-width:  ${({ minWidth }) => (minWidth ? `${minWidth}px` : '375px')};
  background: ${({ theme, isGreyBg }) => (isGreyBg ? theme.greyBg : theme.bg)};
`;

const StyledMain = styled.main`
  flex: 1 1 auto;
`;
const StyledContent = styled.div`
  margin: auto;
  width: 100%;
`;

const StyledCommonContent = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  padding: 60px 0 200px;
`;

const InnerContent = styled.div`
  color: ${({ theme }) => theme.fontColor};
  display: flex;
  flex-direction: column;
  transition: color 0.6s ease-out;
  a,
  a:visited,
  a:focus {
    color: ${({ theme }) => theme.fontColor};
    outline: none;
    text-decoration: none;
  }
`;

const QuestionReSearch = styled.a`
  height: 51px;
  background: linear-gradient(270deg, rgba(251, 218, 60, 1) 0%, rgba(240, 185, 11, 1) 100%);
  border-radius: 25px;
  padding: 18px;
  box-sizing: border-box;
  line-height: 16px;
  position: fixed;
  right: 24px;
  bottom: 80px;
  cursor: pointer;
  z-index: ${zIndexScale.shade};
  img {
    margin-bottom: 3px;
  }
  span {
    font-size: 16px;
    font-family: ${({ theme }) => theme.fontIBMSemiBold};
    font-weight: 600;
    color: rgba(0, 0, 0, 1);
    margin-left: 5px;
  }
`;

const mapStateToProps = ({ userInfo, isHideHeadLangSeclet }) => ({
  userInfo,
  isHideHeadLangSeclet,
});
const mapDispatchToProps = {
  verifyToken: verifyTokenRequest,
  userLoggedOut: userLoggedOutRequest,
  fetchInmailData,
  fetchInmailUnreadCount,
  addInmailData,
  updateInmailDataCount,
};

export default
@connect(mapStateToProps, mapDispatchToProps)
@withRouter
class Layout extends Component {
  static propTypes = {
    children: PropTypes.node,
    locale: PropTypes.string,
    metaData: PropTypes.shape({
      title: PropTypes.string.isRequired,
      keywords: PropTypes.string,
      description: PropTypes.string,
      ogImage: PropTypes.string,
    }),
    withTradingView: PropTypes.bool,
    withJpush: PropTypes.bool,
    omitHeader: PropTypes.bool,
    omitFooter: PropTypes.bool,
    hasQuestionCallback: PropTypes.bool,
    omitFooterTotalUpdate: PropTypes.bool,
    both: PropTypes.array,
    selectedPair: PropTypes.string,
    isGreyBg: PropTypes.bool,
    isBisicTradePage: PropTypes.bool,
    content: PropTypes.node,
    commonContent: PropTypes.bool,
    router: PropTypes.object,
    hostName: PropTypes.string,
    userInfo: PropTypes.object,
    shouldHeaderFixed: PropTypes.bool,
    minWidth: PropTypes.number,
    isUserCenter: PropTypes.bool,
    verifyToken: PropTypes.func,
    userLoggedOut: PropTypes.func,
    omitVerifyToken: PropTypes.bool,
    locales: PropTypes.object,
    isHideHeadLangSeclet: PropTypes.bool,
    omitHeaderLangSelect: PropTypes.bool,
    isShowEmergencyNotice: PropTypes.bool,
    omitFireFoxWarningTip: PropTypes.bool,
    emitAmp: PropTypes.bool,
    useTwitterTracking: PropTypes.bool,
    fetchInmailData: PropTypes.func,
    fetchInmailUnreadCount: PropTypes.func,
    addInmailData: PropTypes.func,
    updateInmailDataCount: PropTypes.func,
    fetchInmailDataInPage: PropTypes.func,
  };

  static defaultProps = {
    locale: 'en',
    metaData: {},
    withTradingView: false,
    omitHeader: false,
    omitFooter: false,
    hasQuestionCallback: false,
    omitFooterTotalUpdate: true,
    both: ['BTC', 'USDT'], // TODO: improve.
    selectedPair: 'BTC_USDT',
    isGreyBg: false,
    isBisicTradePage: false,
    content: null,
    commonContent: false,
    children: null,
    router: { asPath: '/' },
    hostName: 'www.binance.us',
    shouldHeaderFixed: false,
    minWidth: 1200,
    isUserCenter: false,
    omitVerifyToken: false,
    omitHeaderLangSelect: false,
    isShowEmergencyNotice: true,
    omitFireFoxWarningTip: true,
    emitAmp: false,
    useTwitterTracking: false,
    fetchInmailData: () => {},
    fetchInmailUnreadCount: () => {},
    addInmailData: () => {},
    updateInmailDataCount: () => {},
    fetchInmailDataInPage: () => {},
    refeshInmailData: () => {},
  };

  state = { token: '' };

  static getDerivedStateFromProps(nextProps, prevState) {
    const userId = nextProps.userInfo?.userData?.userId;

    if (typeof window !== 'undefined') {
      // set chat pathname and lang
      window?.localStorage?.setItem('chatGetPath', nextProps.router.pathname);
      window?.localStorage?.setItem('chatLang', nextProps.locale);
    }

    if (prevState?.userId !== userId) {
      login(userId);
    }
    return {
      userId,
    };
  }

  async componentDidMount() {
    const locale = this.props.router.query.locale || 'en';
    createCookie('lang', locale.toUpperCase());

    const { metaData } = this.props;
    gtmTrack({
      event: 'page loading',

      page_load_info: {
        bncuuid: cookies.read('bnc-uuid'),
        userid: cookies.read('userId'),
        pagename: metaData.title || window.location.pathname,
      },
    });

    if (this.props.omitVerifyToken) return;

    const {
      verifyToken,
      router: { pathname },
    } = this.props;

    const verifiedLoggedIn = await verifyToken();
    if (!verifiedLoggedIn) {
      const { redirect } = checkLogin(pathname) || {};
      if (redirect) {
        window.location.href = getLoginUrl(locale);
      }
    } else {
      // update login status when login from other binance site
      createCookie('logined', 'y', 7, true);
      this.props.fetchInmailUnreadCount();

      fetchInmailStreamToken().then((data) => {
        this.setState({ token: data });
      });
      this.props
        .fetchInmailData(
          {
            page: 1,
            rows: 20,
            status: 1,
          },
          true
        )
        .then((data) => {
          this.setState({ messages: data.data });
          this.setState({ messageCount: data.total });
        });
      // this.onMessage()
    }
  }

  onMessage = (data) => {
    if (data.messageType === 'MESSSAGE_TEXT') {
      data.insertTime = data.message.insertTime;
      data.id = data.message.id;
      data.moduleId = data.message.moduleId;
      this.props.addInmailData(data);
      const newMsg = [data, ...this.state.messages];
      if (newMsg.length > 10) newMsg.pop();
      this.setState({ messages: newMsg });
    }
    if (data.messageType === 'UNREAD_MESSAGE_COUNT') {
      this.props.updateInmailDataCount(data.message);
      this.setState({ messageCount: data.message.userNum });
    }
  };

  onreadInmail = (id, fetch) => {
    this.props.fetchInmailDataInPage();
    const params = { status: 2 };
    if (id !== null) params.id = id;

    fetchInmailReadOrDelet({
      ...params,
    }).then(() => {
      if (id) {
        const messages = this.state.messages.filter((x) => x.id !== id);
        this.setState({ messages });
      } else {
        this.setState({ messages: [] });
      }
      // this.setState({ messageCount: this.state.messageCount - 1 });
      if (fetch) {
        this.props.fetchInmailData(
          {
            page: 1,
            rows: 20,
            status: 1,
          },
          true
        );
      }
    });
  };

  render() {
    const {
      children,
      metaData,
      withTradingView,
      withJpush,
      omitHeader,
      omitFooter,
      hasQuestionCallback,
      omitFooterTotalUpdate,
      both,
      selectedPair,
      isGreyBg,
      isBisicTradePage,
      content,
      commonContent,
      router,
      hostName,
      shouldHeaderFixed,
      isUserCenter,
      // locale,
      locales,
      locale,
      isHideHeadLangSeclet,
      isShowEmergencyNotice,
      omitFireFoxWarningTip,
      emitAmp,
      minWidth,
      useTwitterTracking,
      isCompatibleMobile,
    } = this.props;
    const { token, messageCount, messages } = this.state;
    const canonicalUrl = `${getHostName(hostName)}${removeQueryStr(router.asPath)}`;
    const canonicalUrlWithProtocol = !canonicalUrl.startsWith(HTTPS) ? `${HTTPS}${canonicalUrl}` : canonicalUrl;
    const ampHtmlUrl = `${hostName}/${locale}/amp${getPathWithoutLocale(removeQueryStr(router.asPath))}`;
    const ampHtmlUrlWithProtocol = !ampHtmlUrl.startsWith(HTTPS) ? `${HTTPS}${ampHtmlUrl}` : ampHtmlUrl;
    const metaImage = metaData.ogImage || 'https://public.bnbstatic.us/static/images/binance_previewImage.png';
    const origin = `https://${hostName}`;

    return (
      <Fragment>
        <Head>
          <title>{metaData.title}</title>
          {metaData.description && <meta name="description" content={metaData.description} />}
          {metaData.keywords && <meta name="keywords" content={metaData.keywords} />}

          <link rel="shortcut icon" type="image/x-icon" href={`${assetPrefix}/static/images/common/favicon.ico`} />
          <link href={canonicalUrlWithProtocol} rel="canonical" />
          {emitAmp ? <link href={ampHtmlUrlWithProtocol} rel="amphtml" /> : null}

          {/* seo og */}
          <meta property="og:locale" content="en_US" />
          <meta property="og:title" content={metaData.title || 'Binance.US | Buy & Sell Crypto'} />
          <meta
            name="og:description"
            content={metaData.description || 'Trade over 60 cryptocurrencies and enjoy some of the lowest trading fees in the USA.'}
          />
          <meta property="og:type" content="website" />
          <meta property="og:site_name" content="@BinanceUS" />
          <meta property="og:image" content={metaImage} />
          <meta property="og:image:width" content="1200px" />
          <meta property="og:image:width" content="627px" />

          {/* twitter */}
          <meta name="twitter:card" content="summary" />
          <meta name="twitter:site" content="@BinanceUS" />
          <meta name="twitter:title" content={metaData.title || '@BinanceUS | Buy & Sell Crypto.'} />
          <meta
            name="twitter:description"
            content={metaData.description || 'Trade over 60 cryptocurrencies and enjoy some of the lowest trading fees in the USA.'}
          />
          <meta property="twitter:image" content={metaImage} />
          <meta property="twitter:image:src" content={metaImage} />

          <meta name="robots" content="index" />
          <meta name="google-site-verification" content="HMMYH4kF3UUHSTuvbQJe_H4EmsyOV4E7SQ0y6TQNljw" />

          {isCompatibleMobile ? (
            <meta name="viewport" content="width=device-width,minimum-scale=1,initial-scale=1" />
          ) : (
            <meta name="viewport" content="width=1200, user-scalable=yes" />
          )}
          {/* no cdn/asset prefix because content could be dynamic. */}
          {withTradingView && <script src={`${assetPrefix}/static/tradingview/charting_library/charting_library.min.js`} async={true} />}
          {withJpush && <script src={`${assetPrefix}/static/jpush/jpush-sdk-web.min.js?v=${BUILD_ID}`} async={true} />}
          {withJpush && <script src={`${assetPrefix}/static/jpush/helper.js?v=${BUILD_ID}`} async={true} />}
          {withJpush && <script src={`${assetPrefix}/static/jpush/md5.min.js?v=${BUILD_ID}`} async={true} />}
          {useTwitterTracking && <script src={`${assetPrefix}/static/twitterConvertTrack.js?v=${BUILD_ID}`} async={true} />}
        </Head>
        <LocalStorageDataProvider />
        <CommonDataProvider />
        <StyledLayout isGreyBg={isGreyBg} className="layout" isBisicTradePage={isBisicTradePage} minWidth={minWidth}>
          <ReferralDataSetter />
          {token ? <AbstractSocketProvider url={`${inmailWssUrl}${token}`} keepAlive={true} onMessage={this.onMessage} /> : null}
          {!omitHeader && (
            <Header
              both={both}
              selectedPair={selectedPair}
              showScaleAnimation={shouldHeaderFixed}
              isHideHeadLangSeclet={isHideHeadLangSeclet}
              onreadInmail={this.onreadInmail}
              origin={origin}
              inmailFreshData={messages}
              inmailUnreadData={messageCount}
            />
          )}

          <EmergencyNotice shouldHeaderFixed={shouldHeaderFixed} isShowEmergencyNotice={isShowEmergencyNotice} />

          {isUserCenter && <UserCenterHeader />}
          {isUserCenter && <FaceStatus locale={locale} />}
          {!omitFireFoxWarningTip && <FireFoxWarningTip />}
          <SubHead />
          <StyledMain>
            {content ||
              (commonContent ? (
                <StyledCommonContent>{children}</StyledCommonContent>
              ) : (
                <StyledContent isBisicTradePage={isBisicTradePage} isShowEmergencyNotice={isShowEmergencyNotice}>
                  <InnerContent>{children}</InnerContent>
                </StyledContent>
              ))}
          </StyledMain>
          {!omitFooter && <Footer locales={locales} isBisicTradePage={isBisicTradePage} omitFooterTotalUpdate={omitFooterTotalUpdate} />}
          {hasQuestionCallback && (
            <QuestionReSearch
              href={locale === 'tw' || locale === 'cn' ? 'https://www.research.net/r/2QM8SRD?lang=zh' : 'https://www.research.net/r/2QM8SRD'}
              target="_blank"
              rel="noopener noreferrer"
              id="feedback"
            >
              <img src={assetPrefix + require('../static/images/common/commentCallbackIcon.svg')} alt="commentCallbackIcon" />
              <span>Feedback</span>
            </QuestionReSearch>
          )}
        </StyledLayout>
      </Fragment>
    );
  }
}
